function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n      fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M201.5,167.93c-15.19,0-26.5,13.71-26.5,30s11.31,29,26.5,29,26.5-12.71,26.5-29-11.31-30-26.5-30Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M395.36,48.5H104.64c-31,0-56.14,25.13-56.14,56.14v290.72c0,31,25.13,56.14,56.14,56.14h290.72c31,0,56.14-25.13,56.14-56.14V104.64c0-31-25.13-56.14-56.14-56.14ZM146,312.57c0,10.36-.61,13.52-4,20.36-1.81,3.66-3.77,4.85-7,7-3,2-8.28,3-14,3-2.94,0-10.94.52-15-.45l.71-8.23c.15-1.74,1.74-2.99,3.47-2.74,4.22.62,7.01.42,8.82.42,2.82,0,7.6-.71,9.05-1.75,1.45-1.04,2.45-2.64,3.01-4.78.56-2.14,1.84-5.75,1.84-12.82v-49.21h13.1v49.21ZM159,236.93h-45v-79h13v68h32v11ZM228,310.99c0,7.63-.72,13.51-2.15,17.63-1.44,4.12-4.76,7.54-9.97,10.25-5.21,2.71-12.2,4.06-20.96,4.06-6.8,0-12.7-.85-17.71-2.55-5.01-1.7-8.8-4.45-11.37-8.24-2.57-3.8-3.85-10.56-3.85-20.29v-48.49h13.69v48.49c0,5.42,1.58,10.8,3.13,12.99,2.19,3.09,3.49,3.58,6.19,5.09,2.69,1.51,6.32,2.3,10.9,2.3,4.33,0,6.68-1.06,9.1-2.3,2.42-1.24,4.75-3.85,6-6,1.84-3.17,2.67-5.6,2.67-12.31v-48.26h14.33v47.63ZM201.5,237.93c-22.37,0-40.5-18.13-40.5-40.5s18.13-40.5,40.5-40.5,40.5,18.13,40.5,40.5-18.13,40.5-40.5,40.5ZM310,342.93h-5.82c-2.63,0-5.11-1.23-6.7-3.33l-41.47-54.67v58h-11.42v-79.57h5.92c2.21,0,4.3,1.03,5.64,2.78l41.87,54.58v-57.36h12v79.57ZM287.09,236.93l-.28-.44.19.44h-12l-32-79h10.84c1.9,0,3.6,1.18,4.27,2.96l21.89,56.09c.46,1.22.83,2.71,1.05,4.26.21-1.55.58-3.04,1.04-4.26l21.89-56.09c.66-1.78,2.37-2.96,4.27-2.96h10.84l-32,79ZM327,157.68h56v10.5h-41.75v23.5h34.75v10.5h-34.75v23.5h41.75v11.25h-56v-79.25ZM379.89,342.93c-1.98,0-3.86-.88-5.13-2.41l-26.46-31.91c-1.76-2.12-2.3-1.68-7.37-1.68v36h-12.91v-79.57h12.91v34.57c4.06,0,5.65-2.71,6.88-4.18l23.94-27.83c1.43-1.63,3.49-2.57,5.65-2.57h12.37l-29.44,32.85c-1.91,2.13-1.94,5.35-.08,7.52l33.74,39.21h-14.11Z"
});

var SvgLoveJunkLogo = function SvgLoveJunkLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#26A65B"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoveJunkLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/love-junk-logo.aa92d652.svg";
export { ForwardRef as ReactComponent };